import * as _ from 'lodash';
import { AfterViewInit, Component, effect, OnInit, output, OutputEmitterRef, TemplateRef, viewChild } from '@angular/core';

import { IImageParentData } from 'src/app/features/image/models/image-parent-data';
import { ILevelGeneralData } from '../../models/level-general-data';
import { _SectionFormComponent } from './_section-form-component';
import { HttpParams } from '@angular/common/http';
import { filter, finalize, Observable, Subscription, tap } from 'rxjs';
import { ILevelGeneralDto } from '../../models/level-general-dto';
import { pageMode } from '../../models/page-mode';
import { IFooterData } from 'src/app/features/shared/footer/models/footer-data';
import { IHeaderData } from 'src/app/features/shared/header/models/header-data';

@Component({
    selector: 'app-section-details',
    template: '',
    styles: []
})
export abstract class _SectionDetailsComponent<DtoModel extends ILevelGeneralDto, DataModel extends ILevelGeneralData, FormModel>
    extends _SectionFormComponent<DataModel>
    implements OnInit, AfterViewInit
{
    private __onDeleteEmitSubscr?: Subscription;
    
    protected abstract _delete_http$(): Observable<DtoModel>;

    abstract onDelete_httpParams: HttpParams;
    abstract onDelete_requestOptions?: any;

    abstract out_onDelete: OutputEmitterRef<void>;
    abstract out_onEscape: OutputEmitterRef<void>;

    abstract emit_onDelete(): void;
    abstract emit_onEscape(): void;
    abstract ngOnDestroy(): void;

    private __onInit = true;
    private __buttons$$ = viewChild<TemplateRef<any>>('buttons');

    protected _out_onDelete = output({alias:'onDelete'});
    protected _out_onEscape = output({alias:'onEscape'});

    protected override _headerData_section: Partial<IHeaderData> = {
        sideBlockLeft_hide: false
    };
    protected override _footerData_section: Partial<IFooterData> = {
        hideSideBlockLeft: false
    };

    // @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
    //         if (event.key === 'Escape') {
    //             this.emit_esc();
    //         }
    //     }

    constructor() {
        super();

        effect(() => this._centralPageService.sectionEdit_extraButtons_template_set(this.__buttons$$()))
        effect(() => {
            const _dataModel = this.dataModel$$();
            if (!!_dataModel) {
                this._emit_pageLoaded();
            }
        })
    }

    protected override _ngOnInit(): void {
        // const __footer_page = this._pageService.footerData_page$$();
        const __header_page = this._pageService.headerData_page$$();
        const __currentPage = this._pageService.pageCurrent$$();
        const __defaultName = __currentPage?.displayName;

        this._headerData_section = {title: `details ${__header_page?.title ?? __defaultName}`};
        // this._footerData_section = {hideSideBlockLeft: __footer_page?.hideSideBlockLeft ?? false};

        // Details-sectie levert de autorisatiepagina voor de edit/delete-knoppen (details-slot).
        if (this._claimPage) this._centralPageService.pageName_sectionDetails_set(this._claimPage);

        super._ngOnInit();

        this.__onDeleteEmitSubscr = this._centralPageService.onDeleteEmit$
            .pipe(
                filter(_ => !this.__onInit),
                tap(_ => this.emit_onDelete())
            )
            .subscribe();

        this.__onInit = false;
    }

    protected _emit_onDelete(): void {
        this._out_onDelete.emit();
    }

    protected _emit_onEscape(): void {
        this._out_onEscape.emit();
    }

    protected _delete(): void {
        this._delete$()
        .pipe(
            tap(_ => {
                const _page_return = this._pageService.PageReturn;

                this._pageService.page_goto(_page_return);
                this._emit_onEscape();
            })
        )
        .subscribe();
    }

    protected _delete$(): Observable<DtoModel> {
        return this._delete_http$();
    }

    emit_onDirty(dirty: boolean): void {
        super._emit_onDirty(dirty);
    }

    protected _ngOnDestroy(): void {
        this.__onDeleteEmitSubscr?.unsubscribe();
    }
}
